module.exports = __webpack_public_path__ + "img/GI.24c4b025.png";